import styles from "./styles.module.scss";
import EnterPinWidget from "./widget";

export {styles};
export default EnterPinWidget;